import { useListByIdQuery } from '@/app/services/overheadApi';
import PageTitle from '@/components/common/pageTitle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Typography, useTheme } from '@mui/material';
import { grey, orange } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

function OverheadBreadcrumb() {
  const { id: idParam } = useParams();
  const id = Number(idParam);
  const { data } = useListByIdQuery(id, {
    skip: !id,
  });

  const { t } = useTranslation(['overhead', 'common']);
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box>
        {idParam ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PageTitle title={t('overhead')} sx={{ color: orange[600], mb: 1 }} onClick={() => navigate('/overhead')} />
            <ArrowForwardIosIcon
              sx={{
                color: grey[600],
                height: theme.spacing(1.2),
                width: theme.spacing(1.2),
                mx: 1,
                mt: 2,
              }}
            />
            <Typography sx={{ mt: 2 }} variant="h3">{`${data?.project.code}`}</Typography>
          </Box>
        ) : (
          <Box sx={{ mb: 0 }}>
            <PageTitle title={t('overhead')} sx={{ mb: 0 }} />
          </Box>
        )}
      </Box>
      <Outlet />
    </Box>
  );
}
export default OverheadBreadcrumb;
